export default {

    namespaced: true,

    state: {
        operation: null,
        form: {
            model: {
                id: null,
                name: null,
                type: null,
                status: null,
                description: null,
                syncFromShr: null,
            },
        },
    },

    getters: {},

    mutations: {
        setOperation(state, operation) {
            state.operation = operation;
        },
        setFormModel(state, formModel) {
            state.form.model = formModel;
        },
    },

    actions: {},

}